export default __webpack_public_path__ + "static/media/cpLaundryPassPinkZh.d49d0bcf.jpg";